import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FrameService } from '../../../services/frame/frame.service';
import { Subscription } from 'rxjs';
import { SnackbarService } from '../../../services/snackbar/snackbar.service';
import { MatrixService } from '../../../services/matrix/matrix.service';
import { GeneralLoginFlowComponent } from '../../../common/components/general-login-flow/general-login-flow.component';
import { AppConfigService } from '../../../services/config/app-config.service';
import { SbLoginTestIds } from './sb-login.test-ids';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, GeneralLoginFlowComponent],
  templateUrl: './sb-login.component.html',
  styleUrl: './sb-login.component.scss'
})
/**
 * Angular-Komponente für eine Login-Maske.
 * Gibt ein {@link HTMLFormElement HTML-Form} mit drei Inputs zurück:
 * * Homeserver-URL
 * * Username
 * * Password
 *
 * Beim Submit wird das (globale) JS-SDK mit den gegebenen Daten eingeloggt.
 * Das JS-SDK wird so gestartet, dass alle HTTP-Requests den Header `X-TIM-User-Agent` enthalten.
 * Da die einzugebenden Daten identisch sind zu jenen bei einer Registrierung,
 * wird diese Komponente auch zur Registrierung genutzt.
 *
 * @see timFetch
 *
 * Hierdurch erfüllte AFO's:
 *
 * A_25043 - Berechtigungskonfiguration in Accountdaten speichern
 */
export class SbLoginComponent implements OnInit, OnDestroy {
  public readonly snackbarService: SnackbarService = inject(SnackbarService);
  public readonly homeserverHostSubscription: Subscription | undefined;

  protected readonly testIds = SbLoginTestIds;
  private readonly config: AppConfigService = inject(AppConfigService);
  /**
   * FormGroup für das Formular zum Einloggen bzw. Registrieren.
   */
  public readonly loginForm = new FormGroup({
    host: new FormControl(this.config.get('homeserverHostname')),
    user: new FormControl(''),
    pw: new FormControl('')
  });
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly clientService = inject(MatrixService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private redirectUrl: string | null = null;

  constructor() {
    const frameService = inject(FrameService);

    this.homeserverHostSubscription = frameService.subscribeHomeserverHost(host => {
      this.loginForm.patchValue({ host });
    });
  }

  ngOnInit(): void {
    this.redirectUrl = this.route.snapshot.queryParamMap.get('redirect');
  }

  redirectToLogin(): void {
    globalThis.location.href = this.clientService.redirectToSSO(this.config.get('homeserverHostname'));
  }

  async loginViaIDP(): Promise<void> {
    this.oidcSecurityService.authorize('configIdIDP');
  }

  public ngOnDestroy(): void {
    this.homeserverHostSubscription?.unsubscribe();
  }
}
